const urls = {
    initCheckout:() => `${process.env.BASE_API_URL}/api/usr/v2/plans/initCheckout`,
    plansPending:(id) => `${process.env.BASE_API_URL}/api/usr/v2/plans/pending/${id}`,

    ATTIVA_TINABA_HIT: "https://bancaprofilo.tinaba.it/influencer",
    REGOLAMENTO: "https://bancaprofilo.tinaba.it/promozioni-e-regolamenti#voce16",
}

export { urls }